import styled from 'styled-components';
import { Paper } from "@mui/material";

// export const LoginContainer: any = styled.div<{
//     $darkMode?: boolean;
// }>`
//     display: flex;
//     justify-content: center;
//     height: 100vh;
//     width: 100vw; 
//     background: #cbe0f9ff;

//     &::before {
//         content: "";
//         position: absolute;
//         top: 0;
//         left: 0;
//         width: 100%;
//         height: 50%;
//         background: linear-gradient(rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.05));
//         border-top-left-radius: 12px;
//         border-top-right-radius: 12px;
//         pointer-events: none;
//     }
// `;

export const TableContainer = styled(Paper) <{ $darkMode?: boolean; }>`
    overflow: visible;
    border-radius: 5px !important;

    .autoCompleteDropdownContainer {
        width: 15vw;

        .MuiAutocomplete-root.MuiAutocomplete-hasPopupIcon {
            .MuiFormControl-root.MuiFormControl-fullWidth.MuiTextField-root {
                .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-fullWidth.MuiInputBase-formControl.MuiInputBase-adornedEnd.MuiAutocomplete-inputRoot {
                    height: 39px;
                }
            }
        }
    }

    .mantine-qp6lqg {
        border-radius: 0px 0px 5px 5px !important;
    }


    .mantine-xek3z6 {
        .mantine-5estzh {
            .mantine-Text-root {
                text-align: left;
            }
        }
    }

    .mantine-5lkluq {
        border-radius: 0px 0px 5px 5px !important;
        border: solid 1px gray;
        // height: unset !important;
        min-height: 250px;
    }

    .mantine-ooem79,
    .mantine-1095l9t {
        .mantine-Text-root {
            text-align: left;
        }
    }

    .mantine-5estzh {
        background: #1e1e1e;
    }

    .mantine-Group-root {
        .mantine-UnstyledButton-root.mantine-Pagination-control {
            width: 32px;
            height: 32px;
            border: none;

            &:hover {
                color: var(--hrDashboardIconColor) !important;
            }
        }

        .mantine-UnstyledButton-root.mantine-Pagination-control[data-active] {
            color: var(--cardBgPrimaryColor) !important;
            background: var(--hrDashboardIconColor) !important;
        }

        .mantine-Center-root {
            background: transparent !important;
        }
    }

    thead {
        tr {
            th {
                // color: var(--mantineHeaderColor) !important;
                font-size: 13px;
                font-weight: 600;
                padding: 15px 20px;
                text-align: left !important;
                text-transform: uppercase;
                align-content: center;
                font-family: "Inter", sans-serif !important;

                &:last-of-type {
                    display: flex;
                    justify-content: flex-end;
                }
            }
        }
    }

    tbody {
        tr {
            td {
                padding-left: 20px;
                padding-right: 20px;
                font-weight: 400;
                vertical-align: top;
                font-size: 13px;
                height: auto !important;
                white-space: pre-line;
                text-align: left !important;
                align-content: center;
                font-family: "Inter", sans-serif !important;

                &:last-of-type {
                    display: flex;
                    justify-content: flex-end;
                }
            }
        }
    }
`;